import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'home'
  },
  {
    path: 'home',
    loadChildren: () => import('./views/home/home.module').then(m => m.HomeModule)
  },
  {
    path: 'compare',
      loadChildren: () => import('./views/compare/compare.module').then(m => m.CompareModule)
  },
  {
    path: 'docs',
      loadChildren: () => import('./views/docs/docs.module').then(m => m.DocsModule)
  },
  {
    path: 'intro',
    loadChildren: () => import('./views/intro/intro.module').then(m => m.IntroModule)
  },
  {
    path: '**',
    pathMatch: 'full',
    redirectTo: 'home'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
